/**
 * Created by ellis on 23/11/2016.
 */
import { handleActions } from 'redux-actions';
import { VERSION_LIST_SUCC, SYMBOL_LIST_SUCC, RESET_SYMBOL_DATA } from 'store/actions';
import { Map as iMap, List as iList } from 'immutable';
import { initialState } from './initialState';
import isString from 'lodash/lang/isString';

export default handleActions({
  [VERSION_LIST_SUCC]: (state, action) => {
    console.log('versionList 成功获取了', action);
    const { versions = [] } = action.response;
    return state.update('selectOptions', (options) => options.mergeDeep({
      versions: {
        options: iList(versions).map((item) => ({ label: item.version, value: encodeURIComponent(item.version) })).unshift({
          label: '全版本',
          value: '-1',
        }),
      },
    }));
  },
  [SYMBOL_LIST_SUCC]: (state, action) => {
    const { infos, totalCount, tooManyRecords } = action.response || {};

    // 后端检测到记录数超过阈值且前端无搜索条件时，返回 tooManyRecords=true。
    // 此时 infos 为空，不按"无数据"处理，而是用独立状态通知前端展示搜索引导提示。
    if (tooManyRecords) {
      return state
        .set('tooManyRecords', true)
        .set('empty', false)
        .set('selectedType', action.params.symbolType)
        .set('list', iMap({ total: 0, symbols: [] }));
    }

    if (action.params.init && (!infos || !infos.length)) {
      return state
        .set('tooManyRecords', false)
        .set('empty', !!action.params.init)
        .set('list', iMap({ total: 0, symbols: [] }));
    }

    let symbols = [];
    let current = null;
    (infos || []).forEach((item) => {
      if (isString(item.pipelineInfo)) {
        try {
          item.pipelineInfo = JSON.parse(item.pipelineInfo);
        } catch (e) {
          console.error('symbolTableList, parse pipelineInfo error, e = ', e);
          item.pipelineInfo = null;
        }
      }

      if (!current || current.version !== item.version) {
        current = {
          version: item.version,
          list: [],
        };
        symbols.push(current);
      }
      current.list.push(item);
    });
    if (action.params.size === 1) {
      symbols = [];
    }
    const result = {
      total: totalCount,
      symbols,
    };
    return state
      .set('tooManyRecords', false)
      .set('empty', false)
      .set('selectedType', action.params.symbolType)
      .set('list', iMap(result));
  },
  [RESET_SYMBOL_DATA]: (state) => {
    return state.set('selectedType', 3);
  },
}, initialState);
